import { Form, Input, Modal } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  onCancel: () => void
  onOk: () => void
}
export const TemplateTitleModal = ({ onCancel, onOk, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      open
      onCancel={onCancel}
      onOk={onOk}
      centered
      maskClosable={false}
      {...props}
      styles={{
        body: {
          paddingTop: 60
        }
      }}
    >
      <Form.Item
        name="template_name"
        label={t('counterparts.template_name')}
        rules={requiredRules}
      >
        <Input placeholder={t('counterparts.template_name')} />
      </Form.Item>
    </Modal>
  )
}
